import React from 'react';
import { ITables } from '../all-types';

type Props = React.SVGProps<SVGSVGElement> & ITables

const WoodenTableTop: React.FC<Props> = ({
  tableColor = 'url(#woodgrain)',
  capacity,
  width,
  height,
  tableNo,
  isActive,
  status,
  ...rest
}) => {

  const textColor = "#fff";
  
  return (
    <svg width={width || "200"} height={height || "200"} viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg" >
      {/* Woodgrain gradient */}
      {/* <defs>
        <linearGradient id="woodgrain" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={tableColor} />
          <stop offset="50%" stopColor="#8b4513" />
          <stop offset="100%" stopColor="#5a3c1c" />
        </linearGradient>
      </defs> */}

      Tabletop
      <rect
        x="10"
        y="10"
        width="380"
        height="180"
        rx="8"
        ry="8"
        fill={tableColor}
        stroke="#5a3c1c"
        strokeWidth={3}
      />

<rect x="10" y="10" width="380" height="180" rx="8" ry="8" fill="url(#woodgrain)" stroke="#5a3c1c" stroke-width="3"/>

      {/* Table number */}
      <text
        x="200"
        y="95"
        fontSize="80"
        fill={textColor}
        fontWeight="bold"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        T{tableNo}
      </text>

      {/* Capacity */}
      <text
        x="200"
        y="130"
        fontSize="16"
        fill={textColor}
        textAnchor="middle"
        dominantBaseline="middle"
      >
        Capacity: {capacity}
      </text>

      {/* Status indicators
      {status !== "OCCUPIED" && (
        <circle cx="30" cy="30" r="10" fill="red">
          <title>Occupied</title>
        </circle>
      )}
      {isActive === false && (
        <circle cx="370" cy="30" r="10" fill="gray">
          <title>Not Working</title>
        </circle>
      )} */}
    </svg>
  );
};

export {WoodenTableTop};
